import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const PageHeader = ({ title, subtitle, icon, children }) => {
  const { darkMode } = useTheme();

  return (
    <div className="mb-6">
      <div className="flex items-center mb-1">
        {icon && <span className="mr-3 text-primary">{icon}</span>}
        <h1 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
          {title}
        </h1>
      </div>
      {subtitle && (
        <p className={`mt-1 text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          {subtitle}
        </p>
      )}
      {children && (
        <div className="flex flex-wrap gap-2 mt-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
